export type Language = 'sv' | 'en';

export const translations = {
	sv: {
		settings: {
			title: 'Inställningar',
			subtitle: 'Hantera dina kontoinställningar och preferenser',
			accountInfo: 'Kontoinformation',
			email: 'E-postadress',
			emailCannotChange: 'Kan inte ändras',
			emailChangeContact: 'Kontakta support om du behöver ändra din e-postadress',
			preferences: 'Preferenser',
			language: 'Språk',
			languageDescription: 'Välj standardspråk för applikationen',
			passwordChange: 'Ändra lösenord',
			passwordChangeDescription: 'Uppdatera ditt lösenord för säkerhet',
			currentPassword: 'Nuvarande lösenord',
			newPassword: 'Nytt lösenord',
			confirmPassword: 'Bekräfta lösenord',
			changePassword: 'Ändra lösenord',
			changingPassword: 'Ändrar lösenord...',
			passwordChanged: 'Lösenordet har ändrats',
			passwordMismatch: 'Lösenorden matchar inte',
			passwordTooShort: 'Lösenordet måste vara minst 6 tecken',
			contact: 'Kontakta oss',
			contactDescription: 'Skicka ett meddelande till vårt supportteam',
			contactName: 'Namn',
			contactEmail: 'E-post',
			contactSubject: 'Ämne',
			contactMessage: 'Meddelande',
			sendMessage: 'Skicka meddelande',
			sending: 'Skickar...',
			messageSent: 'Meddelandet har skickats! Vi återkommer så snart som möjligt.',
			privacy: 'Integritet',
			exportData: 'Exportera data',
			exportDataDescription: 'Ladda ner en kopia av alla dina data',
			exporting: 'Exporterar...',
			export: 'Exportera',
			accountManagement: 'Kontohantering',
			logout: 'Logga ut',
			logoutDescription: 'Du kan logga ut från ditt konto genom att använda knappen i navigationsmenyn ovan.',
			deleteAccount: 'Radera konto',
			deleteAccountWarning: 'Varning: Detta kommer permanent radera ditt konto och all din data. Denna åtgärd kan inte ångras.',
			deleteAccountConfirm: 'Är du säker på att du vill radera ditt konto? Detta kan inte ångras.',
			deleteAccountConfirm2: 'Detta kommer permanent radera all din data. Är du helt säker?',
			deleting: 'Raderar...',
			deleteAccountButton: 'Radera konto',
			resetProfile: 'Återställa profil och starta om onboarding',
			resetProfileWarning: 'Detta kommer att radera körkort, språk, färdigheter, arbetslivserfarenheter, utbildning och certifikat. Du kan sedan starta om onboarding från Översikt.',
			resetProfileConfirm: 'Är du säker på att du vill återställa din profil? Detta kommer att radera körkort, språk, färdigheter, arbetslivserfarenheter, utbildning och certifikat.',
			resetProfileButton: 'Återställa profil och starta om onboarding',
			resetting: 'Återställer...',
			resetProfileSuccess: 'Profilen har återställts. Du kan nu starta om onboarding från Översikt.',
			help: 'Behöver du hjälp?',
			helpDescription: 'Om du har frågor eller behöver support, kontakta oss via e-post eller kolla vår hjälpsektion.',
		},
		nav: {
			overview: 'Översikt',
			search: 'Sök',
			careerPaths: 'Karriärvägar',
			profile: 'Profil',
			documents: 'Dokument',
			applications: 'Ansökningar',
			interviewBuddy: 'Intervju-Buddy',
			statistics: 'Statistik',
			addJob: 'Lägg till jobb',
			settings: 'Inställningar',
			logout: 'Logga ut',
			logoutTooltip: 'Logga ut från ditt konto',
		},
		search: {
			matchMe: 'Matcha Mig',
			search: 'Sök',
			addJob: 'Lägg till jobb',
			addJobUnderDevelopment: 'Lägg till jobb - Under utveckling',
			comingSoon: 'Denna funktion kommer snart!',
			whatWillThisDo: 'Vad kommer denna funktion att göra?',
			importJobs: 'Importera jobb från externa källor',
			importJobsDesc: 'Lägg till jobbannonser från LinkedIn eller företagswebbplatser direkt i Karrelo för att få tillgång till alla våra funktioner.',
			gapAnalysis: 'Gap-analys för externa jobb',
			gapAnalysisDesc: 'Få en detaljerad analys av vilka färdigheter och erfarenheter du saknar för att matcha jobbet perfekt.',
			matchScore: 'Matchpoäng och CV-generering',
			matchScoreDesc: 'Se hur väl du matchar jobbet och generera ett anpassat CV och personligt brev baserat på jobbannonsen.',
			trackApplications: 'Spåra alla ansökningar på ett ställe',
			trackApplicationsDesc: 'Hantera alla dina jobbansökningar, både från Karrelo och externa källor, i en centraliserad vy.',
			searchPlaceholder: 'Sökroll, nyckelord...',
			searchFieldEmpty: 'Sökfältet kan inte vara tomt. Vänligen ange en sökterm.',
			county: 'Län',
			selectCounty: 'Välj län...',
			selectOneOrMoreCounties: 'Välj ett eller flera län',
			extent: 'Omfattning',
			all: 'Alla',
			fullTime: 'Heltid',
			partTime: 'Deltid',
			selectExtent: 'Välj omfattning',
			filter: 'Filter',
			applyFilter: 'Använd filter',
			published: 'Publicerad',
			today: 'Idag',
			last7Days: 'Senaste 7 dagarna',
			last90Days: 'Senaste 90 dagarna',
			searchingJobs: 'Söker efter jobb...',
			searchingJobsDesc: 'Vi söker igenom jobbannonser för att hitta relevanta resultat.',
			noAdsMatch: 'Inga annonser matchar. Justera filter eller försök med en annan sökning.',
			enterSearchTerms: 'Ange sökord eller plats för att hitta jobbannonser.',
			showing: 'Visar',
			of: 'av',
			ads: 'annonser',
			filteredFrom: 'filtrerade från',
			total: 'totalt',
			previous: 'Föregående',
			next: 'Nästa',
			page: 'Sida',
		},
		addJob: {
			title: 'Lägg till jobb',
			subtitle: 'Lägg till ett jobb manuellt för att få gap-analys, matchpoäng och CV-generering.',
			instructions: 'Instruktioner',
			instructionsDesc: 'Öppna jobbannonsen i din webbläsare (LinkedIn, företagswebbplats, etc.), kopiera jobbbeskrivningen och klistra in den nedan tillsammans med företagsnamn och jobbtitel.',
			companyName: 'Företagsnamn',
			companyPlaceholder: 'Ex: Acme AB',
			jobTitle: 'Jobbtitel',
			jobTitlePlaceholder: 'Ex: Frontend-utvecklare',
			jobDescription: 'Jobbbeskrivning',
			descriptionPlaceholder: 'Klistra in eller skriv jobbbeskrivningen här...',
			location: 'Plats',
			optional: 'valfritt',
			locationPlaceholder: 'Ex: Stockholm, Sverige',
			createJob: 'Skapa jobb',
			creatingJob: 'Skapar jobb...',
			mustBeLoggedIn: 'Du måste vara inloggad',
			requiredFields: 'Företag, titel och beskrivning är obligatoriska',
			featureDisabled: 'Denna funktion är för närvarande inaktiverad',
			couldNotCreateJob: 'Kunde inte skapa jobbet',
			errorOccurred: 'Ett fel inträffade',
		},
		matchMe: {
			matchYourProfile: 'Matcha din profil med jobb',
			analyzeProfileDesc: 'Klicka på knappen nedan för att analysera din profil och få förslag på lämpliga jobbtitlar.',
			analyzeMyProfile: 'Analysera min profil',
			profileAnalysis: 'Profilanalys',
			profileChanged: 'Din profil har ändrats',
			profileChangedDesc: 'Klicka på "Uppdatera profilanalys" för att få nya förslag baserat på dina ändringar.',
			suitableJobTitles: 'Lämpliga jobbtitlar',
			selectTitles: 'Välj titlar',
			updateAnalysis: 'Uppdatera analys',
			updateProfileAnalysis: 'Uppdatera profilanalys',
			selectJobTitlesToMatch: 'Välj jobbtitlar att matcha mot',
			allTitles: 'Alla titlar',
			clear: 'Rensa',
			optimizedSearch: 'Optimerad sökning',
			optimizedSearchDesc: 'Vi använder de 2 mest relevanta varianterna per titel och max 10 söktermer totalt för snabbare resultat och bättre prestanda. Du kan välja alla titlar - systemet prioriterar automatiskt de bästa matchningarna.',
			backToProfileAnalysis: 'Tillbaka till profilanalys',
			searchWithSelectedTitles: 'Sök med valda titlar',
			filterResults: 'Filtrera resultat',
			backToTitleSelection: 'Tillbaka till titelval',
			selectCounty: 'Välj län...',
			selectOneOrMoreCounties: 'Välj ett eller flera län',
			selectExtent: 'Välj omfattning',
			published: 'Publicerad',
			today: 'Idag',
			last7Days: 'Senaste 7 dagarna',
			last90Days: 'Senaste 90 dagarna',
			matchMe: 'Matcha mig',
			filtering: 'Filtrerar...',
			searching: 'Söker...',
			searchingRelevantJobs: 'Söker efter relevanta jobb...',
			searchingJobsDesc: 'Vi söker igenom tusentals jobbannonser för att hitta de bästa matchningarna för dig.',
			calculatingMatchScore: 'Beräknar matchningspoäng...',
			calculatingMatchScoreDesc: 'Vi analyserar varje jobbannons mot din profil för att ge dig de mest relevanta resultaten.',
			backToFilters: 'Tillbaka till filter',
			filterBySelectedCounties: 'Filtrera efter valda län',
			filterBySelectedTitles: 'Filtrera efter valda titlar',
			title: 'Titel',
			selectTitlesPlaceholder: 'Välj titlar...',
			noTitlesSelected: 'Inga jobbtitlar valda. Vänligen välj minst en titel.',
			errorOccurred: 'Ett fel uppstod',
			couldNotCalculateMatchScore: 'Kunde inte beräkna matchningspoäng.',
			noJobsFound: 'Inga jobb med minst 20% matchning hittades. Prova att uppdatera din profil med fler färdigheter eller erfarenheter.',
			mustBeLoggedIn: 'Du måste vara inloggad för att använda Matcha Mig-funktionen.',
			loginCheckError: 'Ett fel uppstod vid inloggningskontrollen.',
			fetchingJobAds: 'Hämtar jobbannonserna...',
			scopeAll: 'Alla',
			scopeFullTime: 'Heltid',
			scopePartTime: 'Deltid',
			scopeTemporary: 'Visstid',
			scopePermanent: 'Tillsvidare',
			scopeSummerJob: 'Sommarjobb',
			scopeInternship: 'Praktik',
		},
		profile: {
			title: 'Profil',
			basicInfo: 'Grundläggande information',
			name: 'Namn',
			fullName: 'Fullständigt namn',
			phoneNumber: 'Telefonnummer',
			phonePlaceholder: 't.ex. +46 70 123 45 67',
			linkedin: 'LinkedIn-profil',
			linkedinPlaceholder: 'https://linkedin.com/in/ditt-namn',
			email: 'E-post',
			emailCannotChange: 'E-post kan ändras via kontoinställningar',
			notSpecified: 'Inte angivet',
			edit: 'Redigera',
			save: 'Spara',
			cancel: 'Avbryt',
			drivingLicense: 'Körkort',
			hasLicense: 'Har körkort med följande behörigheter:',
			noLicense: 'Har inget körkort',
			languages: 'Språk',
			level: 'Nivå',
			addLanguage: 'Lägg till nytt språk',
			searchLanguage: 'Sök språk...',
			add: 'Lägg till',
			skills: 'Färdigheter',
			suggestSkills: 'Föreslå färdigheter',
			suggestions: 'Förslag',
			newSkill: 'Ny färdighet',
			experiences: 'Erfarenhet',
			noExperiences: 'Ingen erfarenhet tillagd.',
			addExperience: 'Lägg till ny erfarenhet',
			employer: 'Arbetsgivare',
			role: 'Roll/titel',
			startDate: 'Startdatum',
			endDate: 'Slutdatum',
			ongoing: 'Pågående',
			jobDescription: 'Arbetsbeskrivning',
			jobDescriptionPlaceholder: 'Beskriv dina arbetsuppgifter och ansvarsområden...',
			education: 'Utbildning',
			noEducation: 'Ingen utbildning tillagd.',
			school: 'Skola',
			degree: 'Examen',
			fieldOfStudy: 'Inriktning',
			levelPlaceholder: 'Nivå',
			addEducation: 'Lägg till',
			certifications: 'Certifieringar',
			noCertifications: 'Inga certifieringar tillagda.',
			certName: 'Namn',
			issuer: 'Utfärdare',
			issuedAt: 'Utfärdat',
			expiresAt: 'Utgår',
		},
		documents: {
			title: 'Mina dokument',
			subtitle: 'Hantera dina AI-genererade CV:n och personliga brev grupperade per jobbannons',
			loading: 'Laddar dokument...',
			jobAds: 'Jobbannonser',
			cvs: 'CV:n',
			coverLetters: 'Personliga brev',
			noDocuments: 'Inga dokument ännu',
			noDocumentsDesc: 'Generera din första ATS-optimerade CV eller personligt brev från en jobbannons.',
			searchJobs: 'Sök jobb',
			jobId: 'Jobb ID',
			created: 'Skapad',
			deleteAll: 'Ta bort alla',
			cv: 'CV',
			coverLetter: 'Personligt brev',
			delete: 'Ta bort',
			noCv: 'Inget CV',
			noCoverLetter: 'Inget personligt brev',
			atsKeywords: 'ATS-nyckelord:',
			deleteConfirm: 'Är du säker på att du vill ta bort detta',
			deleteConfirmAll: 'Är du säker på att du vill ta bort alla dokument för detta jobb? Detta tar bort både CV och personligt brev.',
			couldNotDelete: 'Kunde inte ta bort dokumentet',
			errorOccurred: 'Ett fel inträffade',
			downloadFailed: 'Nedladdning misslyckades:',
			searchJobTitle: 'Sök efter jobbtitel',
			searchJobTitlePlaceholder: 'Sök efter jobbtitel eller företag...',
			dateFrom: 'Från datum',
			dateTo: 'Till datum',
		},
		applications: {
			title: 'Ansökningar',
			subtitle: 'Dra och släpp kort för att uppdatera status',
			subtitleMobile: 'Tryck på menyn för att ändra status',
			aiHelpExplanation: 'Knappen "Fråga AI" ger dig hjälp baserat på ansökningens status:\n• Skapar ansökningsmail och besvarar ATS-frågor (sparade)\n• Hjälper dig inför och efter en jobbintervju (intervjuer)\n• Skriver uppföljningsmail (avslagna)',
			totalApplications: 'ansökningar totalt',
			noApplications: 'Inga ansökningar än',
			noApplicationsDesc: 'Spara jobbannonser för att börja spåra dina ansökningar.',
			searchJobs: 'Sök jobb',
			saved: 'Sparade',
			applied: 'Ansökta',
			interviews: 'Intervjuer',
			offers: 'Erbjudanden',
			rejected: 'Avslagna',
			noApplicationsHere: 'Inga ansökningar här',
			changeStatus: 'Ändra status',
			match: 'match',
			appliedOn: 'Ansökt:',
			interviewOn: 'Intervju:',
			view: 'Visa',
			help: 'Fråga AI',
			applicationHelp: 'Öppna ansökningshjälp',
			mustApplyFirst: 'Ansökan måste markeras som "Ansökt" innan den kan flyttas till andra statusar',
			mustBeLoggedIn: 'Du måste vara inloggad',
			couldNotLoad: 'Kunde inte ladda ansökningar',
			errorOccurred: 'Ett fel inträffade',
			tryAgain: 'Försök igen',
		},
		statistics: {
			title: 'Statistik',
			subtitle: 'Analysera dina ansökningar och spåra dina framsteg',
			subtitleWithTime: 'Analysera dina ansökningar och spåra dina framsteg över tid',
			noApplications: 'Inga ansökningar än',
			noApplicationsDesc: 'Spara jobbannonser för att börja se statistik.',
			searchJobs: 'Sök jobb',
			mustBeLoggedIn: 'Du måste vara inloggad',
			couldNotLoad: 'Kunde inte ladda ansökningar',
			errorOccurred: 'Ett fel inträffade',
			tryAgain: 'Försök igen',
			exportApplications: 'Exportera ansökningar',
			exportDesc: 'Exportera dina ansökta jobb för aktivitetsrapport till Arbetsförmedlingen',
			selectMonth: 'Välj en månad att exportera',
			exporting: 'Exporterar...',
			exportToExcel: 'Exportera till Excel',
			noAppliedJobs: 'Inga ansökta jobb än',
			noAppliedJobsDesc: 'Markera jobb som "Ansökta" i Ansökningar för att exportera',
			averagePerMonth: 'Genomsnitt per månad',
			sinceFirstJob: 'Sedan första jobbet',
			month: 'månad',
			months: 'månader',
			noDataYet: 'Ingen data än',
			activeApplications: 'Aktiva ansökningar',
			ongoingProcesses: 'Pågående processer',
			monthlyTrend: 'Månadsvis trend',
			applicationsPerMonth: 'Antal ansökningar per månad',
			sinceFirstJobDesc: 'Antal ansökningar per månad sedan första jobbet',
			statusDistribution: 'Statusfördelning',
			statusDistributionDesc: 'Fördelning av dina ansökningar efter status',
			statusDistributionBar: 'Statusfördelning (stapeldiagram)',
			statusDistributionBarDesc: 'Antal ansökningar per status',
			applications: 'Ansökningar',
		},
		dashboard: {
			welcome: 'Välkommen till Karrelo',
			greetingPrefix: 'Hej',
			greetingSuffix: '!',
			overview: 'Här är en översikt av din karriärresa',
			completeProfile: 'Komplettera din profil',
			completeProfileDesc: 'För att få bättre matchningar behöver vi veta mer om dig.',
			getStarted: 'Kom igång',
			applications: 'Ansökningar',
			activeApplications: 'Aktiva ansökningar',
			savedJobs: 'Sparade jobb',
			profileComplete: 'Profil komplett',
			profileIncomplete: 'Profil ofullständig',
			quickActions: 'Snabbåtgärder',
			searchJobs: 'Sök jobb',
			searchJobsDesc: 'Hitta jobb som matchar din profil med AI-driven matchning',
			exploreCareers: 'Utforska karriärvägar',
			exploreCareersDesc: 'Få personliga jobbförslag baserat på din profil',
			viewProfile: 'Uppdatera profil',
			viewProfileDesc: 'Lägg till färdigheter, erfarenheter och utbildning för bättre matchningar',
			viewApplications: 'Hantera ansökningar',
			viewApplicationsDesc: 'Se och spåra alla dina ansökningar på ett ställe',
			getStartedTitle: 'Kom igång med Karrelo',
			getStartedDesc: 'Slutför din profil för att få bättre jobbmatchningar och personliga CV-förslag. Det tar bara några minuter!',
			startOnboarding: 'Kom igång!',
			totalApplications: 'Totala ansökningar',
			totalApplicationsDesc: 'Alla ansökningar du spårat',
			activeApplicationsDesc: 'Pågående processer',
			savedJobsDesc: 'Jobb att ansöka till senare',
		},
		company: {
			auth: {
				loginRequired: 'Vänligen logga in',
			},
			errors: {
				loadCompany: 'Kunde inte ladda företagsinformation',
				companyNotFound: 'Företaget hittades inte.',
				loadDashboard: 'Kunde inte ladda dashboarddata',
				noDashboardData: 'Ingen dashboarddata tillgänglig.',
				loadSettings: 'Kunde inte ladda inställningar',
				saveSettings: 'Kunde inte spara inställningar',
				loadJobs: 'Kunde inte ladda jobb',
				loadAnalytics: 'Kunde inte ladda analys',
				createCompany: 'Kunde inte skapa företag',
				uploadLogo: 'Kunde inte ladda upp logotyp',
				updateCompany: 'Kunde inte uppdatera företaget',
				save: 'Kunde inte spara',
				loadApplications: 'Kunde inte ladda ansökningar',
				loadInterviews: 'Kunde inte ladda intervjuer',
				unknown: 'Okänt fel',
				unauthorized: 'Obehörig',
				loadApplication: 'Kunde inte ladda ansökan',
				updateStage: 'Kunde inte uppdatera steg',
				addNote: 'Kunde inte lägga till anteckning',
				loadTeam: 'Kunde inte ladda teamet',
			},
			actions: {
				retry: 'Försök igen',
				settings: 'Inställningar',
				createJob: 'Skapa nytt jobb',
				logout: 'Logga ut',
				openMenu: 'Öppna meny',
				closeMenu: 'Stäng meny',
				clear: 'Rensa',
				clearSearch: 'Rensa sökning',
				clearFilters: 'Rensa filter',
				saving: 'Sparar...',
				saveChanges: 'Spara ändringar',
				actions: 'Åtgärder',
				edit: 'Redigera',
				preview: 'Förhandsvisa',
				review: 'Granska',
				download: 'Ladda ner',
				remove: 'Ta bort',
			},
			layout: {
				portal: 'Företagsportal',
				companyLabel: 'Företag',
				lightMode: 'Ljust läge',
				darkMode: 'Mörkt läge',
				switchToLight: 'Växla till ljust läge',
				switchToDark: 'Växla till mörkt läge',
			},
			nav: {
				dashboard: 'Översikt',
				jobs: 'Jobb',
				applications: 'Ansökningar',
				interviews: 'Intervjuer',
				analytics: 'Analys',
				team: 'Team',
				settings: 'Inställningar',
			},
			dashboard: {
				activeJobs: 'Aktiva jobb',
				totalApplications: 'Totalt antal ansökningar',
				newApplications: 'Nya ansökningar',
				toReview: 'Att granska',
				upcomingInterviews: 'Intervjuer',
				quickActions: 'Snabbåtgärder',
				manageJobs: 'Hantera jobb',
				manageJobsDesc: 'Visa, redigera och skapa jobbannonser',
				reviewApplications: 'Granska ansökningar',
				reviewApplicationsDesc: 'Granska och hantera ansökningar',
				scheduleInterviews: 'Boka intervjuer',
				scheduleInterviewsDesc: 'Hantera kandidatintervjuer',
				manageTeam: 'Hantera team',
				manageTeamDesc: 'Lägg till och hantera teammedlemmar',
				recentActivity: 'Senaste aktivitet',
				noRecentActivity: 'Ingen senaste aktivitet',
				viewAllActivity: 'Visa all aktivitet →',
				upcomingInterviewsTitle: 'Kommande intervjuer',
				noUpcomingInterviews: 'Inga kommande intervjuer',
				viewAllInterviews: 'Visa alla intervjuer →',
			},
			jobs: {
				title: 'Jobbannonser',
				subtitle: 'Skapa och hantera dina jobbannonser',
				statusDraft: 'Utkast',
				statusScheduled: 'Schemalagd',
				statusExpired: 'Utgången',
				statusActive: 'Aktiv',
				filters: 'Filter',
				filter: 'Filter',
				search: 'Sök',
				filterAll: 'Alla jobb',
				filterDrafts: 'Utkast',
				searchPlaceholder: 'Sök jobb...',
				noJobsTitle: 'Inga jobb hittades',
				noJobsFiltered: 'Justera sökning eller filter',
				noJobsEmpty: 'Skapa din första jobbannons för att komma igång',
				tableTitle: 'Jobbtitel',
				tableLocation: 'Plats',
				tableStatus: 'Status',
				tableApplications: 'Ansökningar',
				tableCreated: 'Skapad',
				viewApplications: 'Visa ansökningar',
				noLocation: 'Ingen plats angiven',
			},
			activity: {
				title: 'Aktivitet',
				subtitle: 'Aktivitetsflöde kommer snart.',
			},
			analytics: {
				title: 'Rekryteringsanalys',
				subtitle: 'Följ rekryteringsmått och optimera processen',
				dateRange: 'Datumintervall:',
				range7d: 'Senaste 7 dagarna',
				range30d: 'Senaste 30 dagarna',
				range90d: 'Senaste 90 dagarna',
				rangeAll: 'Hela perioden',
				jobFilter: 'Jobb:',
				noAccess: 'Du har inte åtkomst till företagets analys.',
				noData: 'Ingen analysdata tillgänglig.',
				totalApplications: 'Totala ansökningar',
				conversionRate: 'Konverteringsgrad',
				timeToHire: 'Tid till anställning',
				days: 'dagar',
				totalHires: 'Totala anställningar',
				applicationsOverTime: 'Ansökningar över tid',
				applications: 'Ansökningar',
				jobPerformance: 'Jobbprestanda',
				views: 'Visningar',
				interviews: 'Intervjuer',
				hires: 'Anställningar',
				applicationSources: 'Ansökningskällor',
				timeToHireByStage: 'Tid till anställning per steg',
				avgTime: 'Genomsnittlig tid',
				avgDays: 'Genomsnittliga dagar',
				candidatesByStage: 'Kandidater per steg',
				candidates: 'Kandidater',
				topSkills: 'Toppkompetenser',
				count: 'Antal',
				exportCsv: 'Exportera CSV',
				exportPdf: 'Exportera PDF',
			},
			interviews: {
				title: 'Intervjuer',
				subtitle: 'Hantera planerade intervjuer',
				defaultType: 'Telefonintervju',
				statusScheduled: 'Planerad',
				statusCompleted: 'Genomförd',
				statusCancelled: 'Avbokad',
				emptyTitle: 'Inga intervjuer hittades',
				emptySubtitle: 'Boka intervjuer från sidan Ansökningar',
				emptyFiltered: 'Inga intervjuer med status',
				tableCandidate: 'Kandidat',
				tableJob: 'Jobb',
				tableScheduled: 'Planerad',
				tableType: 'Typ',
				tableStatus: 'Status',
				viewApplication: 'Visa ansökan',
			},
			filters: {
				all: 'Alla',
			},
			applications: {
				title: 'Ansökningar',
				subtitle: 'Hantera och följ kandidaters ansökningar',
				filters: 'Filter',
				search: 'Sök',
				job: 'Jobb',
				stage: 'Steg',
				view: 'Vy',
				scoreStatus: 'Poängstatus',
				tabOverview: 'Översikt',
				tabAiSummary: 'AI-sammanfattning',
				tabCvDocuments: 'CV & dokument',
				tabQuestions: 'Urvalsfrågor',
				tabNotes: 'Anteckningar',
				showMore: 'Visa mer',
				showLess: 'Visa mindre',
				more: 'till',
				comingSoon: 'Kommer snart',
				overviewMatch: 'Matchning',
				overviewMatchSubtitle: 'Snabb överblick av matchning och bevis',
				overviewStrengths: 'Styrkor',
				overviewRisks: 'Risker / gaps',
				openAiSummary: 'Öppna AI-sammanfattning',
				applicant: 'Kandidat',
				latestNotes: 'Senaste anteckningar',
				latestNotesSubtitle: 'Samarbete och uppföljning på ett ställe',
				openNotes: 'Öppna anteckningar',
				evidenceSkills: 'Nyckelkompetenser',
				evidenceSubtitle: 'Signaler från sammanfattning och CV',
				noEvidence: 'Inga tydliga nyckelkompetenser hittades ännu.',
				noStrengths: 'Inga styrkor angivna.',
				noRisks: 'Inga risker/gaps angivna.',
				noAiSummary: 'Ingen AI-sammanfattning ännu. Generera den för att få en snabb översikt.',
				coverLetterSubtitle: 'Visa och läs kandidatens personliga brev',
				noCoverLetter: 'Inget personligt brev.',
				resumeSubtitle: 'Öppna eller ladda ner kandidatens CV',
				questionsSubtitle: 'Svar på urvalsfrågor och screening',
				noQuestions: 'Inga urvalsfrågor hittades.',
				dangerZone: 'Riskzon',
				dangerZoneSubtitle: 'Radera ansökan (kan inte ångras).',
				total: 'Totala ansökningar',
				new: 'Nya ansökningar',
				inInterview: 'I intervju',
				offersSent: 'Erbjudanden skickade',
				allStages: 'Alla steg',
				stageNew: 'Ny',
				stageReviewed: 'Granskad',
				stageInterview: 'Intervju',
				stageAssessment: 'Test',
				stageReferenceCheck: 'Referenskontroll',
				stageOffer: 'Erbjudande',
				stageHired: 'Anställd',
				stageRejected: 'Avslagen',
				stageOther: 'Övrigt',
				stageUnknown: 'Okänt steg',
				stageOutsideTemplate: 'Detta steg finns inte i den valda pipelinen.',
				viewKanban: 'Kanban',
				viewList: 'Lista',
				searchPlaceholder: 'Sök kandidater...',
				matchScoreAny: 'Matchpoäng: alla',
				matchScoreAbove40: 'Matchpoäng ≥ 40%',
				matchScoreAbove60: 'Matchpoäng ≥ 60%',
				matchScoreAbove80: 'Matchpoäng ≥ 80%',
				scoreStatusAll: 'Poängstatus: alla',
				scoreStatusDone: 'Poängstatus: klar',
				scoreStatusPending: 'Poängstatus: pågår',
				scoreStatusFailed: 'Poängstatus: misslyckad',
				showStages: 'Visa steg',
				emptyTitle: 'Inga ansökningar hittades',
				emptyFiltered: 'Justera dina filter',
				emptyDefault: 'Publicera ett jobb för att få ansökningar',
				candidates: 'kandidater',
				noApplications: 'Inga ansökningar',
				tableApplicant: 'Sökande',
				tableJob: 'Jobb',
				tableStage: 'Steg',
				tableScore: 'Matchpoäng',
				tableApplied: 'Ansökt',
				tableUpdated: 'Uppdaterad',
				unassigned: 'Oklassificerad',
				scoring: 'Poängsätter...',
				updating: 'Uppdaterar...',
				notFound: 'Ansökan hittades inte.',
				backToList: 'Tillbaka till ansökningar',
				backToApplication: 'Tillbaka till ansökan',
				applicationFor: 'Ansökan för',
				appliedOn: 'Ansökt',
				email: 'E-post',
				phone: 'Telefon',
				linkedinProfile: 'LinkedIn-profil',
				matchScore: 'Matchpoäng',
				coverLetter: 'Personligt brev',
				cvSummary: 'CV-sammanfattning',
				cvSummaryExecutive: 'Sammanfattning',
				cvSummaryStrengths: 'Styrkor (för detta jobb)',
				cvSummaryWeaknesses: 'Utvecklingsområden',
				cvSummaryRelevance: 'Matchning mot jobbet',
				cvSummaryHighlights: 'Höjdpunkter',
				cvSummarySkills: 'Toppkompetenser',
				cvSummaryExperience: 'Erfarenhet',
				cvSummaryYears: 'år erfarenhet',
				cvSummaryRoles: 'Senaste roller',
				cvSummaryEducation: 'Utbildning',
				generateAiSummaryTest: 'Generera AI-sammanfattning (test)',
				screeningQuestions: 'Urvalsfrågor',
				question: 'Fråga',
				resume: 'CV',
				resumeFile: 'CV.pdf',
				viewResume: 'Visa CV',
				noResume: 'Inget CV uppladdat',
				stageTitle: 'Ansökningssteg',
				currentStage: 'Nuvarande steg',
				quickActions: 'Snabbåtgärder',
				scheduleInterview: 'Boka intervju',
				sendEmail: 'Skicka e-post',
				offerStageNotFound: 'Erbjudandesteget hittades inte',
				rejectedStageNotFound: 'Avslagsteget hittades inte',
				extendOffer: 'Ge erbjudande',
				reject: 'Avslå',
				notes: 'Anteckningar',
				addNotePlaceholder: 'Lägg till en anteckning...',
				privateNote: 'Privat anteckning',
				privateNoteSelf: 'Privat anteckning (endast synlig för dig)',
				addNote: 'Lägg till anteckning',
				userFallback: 'Användare',
				noNotes: 'Inga anteckningar ännu',
				currentUser: 'Aktuell användare',
				teamNotesTitle: 'Teamanteckningar och samarbete',
				addNoteMentionPlaceholder: 'Lägg till en anteckning eller nämn en teammedlem med @',
				teamNotes: 'Teamanteckningar',
				noNotesCta: 'Inga anteckningar ännu. Lägg till den första!',
				private: 'Privat',
				adding: 'Lägger till...',
				deleteApplication: 'Ta bort ansökan',
				deleteApplicationConfirm: 'Är du säker på att du vill ta bort denna ansökan? Kandidaten och all relaterad information tas bort permanent.',
				deleteApplicationSuccess: 'Ansökan borttagen',
				couldNotDeleteApplication: 'Kunde inte ta bort ansökan',
				deleting: 'Tar bort...',
			},
			onboarding: {
				websiteLocationRequired: 'Fyll i webbplats och plats.',
				completeSuccess: 'Onboarding klart!',
				title: 'Välkommen! Slutför onboarding',
				subtitle: 'Vi behöver lite grundläggande information för att göra din företagssida komplett.',
				website: 'Företagets webbplats',
				websitePlaceholder: 'https://example.com',
				location: 'Plats',
				locationPlaceholder: 't.ex. Stockholm, Sverige',
				logo: 'Logotyp (valfritt)',
				logoAlt: 'Företagslogotyp',
				upload: 'Ladda upp',
				logoHint: 'PNG, JPG, WEBP eller SVG. Max 5 MB.',
				complete: 'Slutför onboarding',
			},
			settings: {
				title: 'Företagsinställningar',
				subtitle: 'Hantera företagsprofil och preferenser',
				generalTab: 'Allmänt',
				pipelineTab: 'Rekryteringsflöde',
				companyNameLabel: 'Företagsnamn *',
				industryLabel: 'Bransch',
				industryPlaceholder: 't.ex. Teknologi, Hälsa, Finans',
				websiteLabel: 'Webbplats',
				websitePlaceholder: 'https://example.com',
				descriptionLabel: 'Beskrivning',
				descriptionPlaceholder: 'Berätta om företaget...',
				saveSuccess: 'Inställningarna sparades',
			},
			pipeline: {
				title: 'Pipeline-inställningar',
				subtitle: 'Anpassa stegen i er rekryteringsprocess',
				firstStageRequired: 'Första steget (Ny) kan inte tas bort.',
				loadError: 'Kunde inte ladda pipeline-data',
				templatesTitle: 'Pipeline-mallar',
				templatesSubtitle: 'Välj en mall att anpassa eller skapa en ny',
				stagesTitle: 'Pipeline-steg',
				stagesSubtitle: 'Dra och släpp för att ändra ordning. Klicka för att redigera.',
				defaultTemplate: 'Standardpipeline',
				defaultTemplateDesc: 'Standardrekryteringsflöde för alla tjänster',
				technicalTemplate: 'Tekniska roller',
				technicalTemplateDesc: 'Flöde med fokus på tekniska tester',
				executiveTemplate: 'Ledningsrekrytering',
				executiveTemplateDesc: 'Flöde för ledande befattningar',
				createTemplate: 'Skapa mall',
				createTemplateTitle: 'Skapa ny mall',
				addStage: 'Lägg till steg',
				addStageTitle: 'Lägg till nytt steg',
				stageCatalogLabel: 'Välj befintligt steg',
				stageCatalogPlaceholder: 'Välj från katalogen',
				defaultTag: 'Standard',
				templateName: 'Mallnamn*',
				templateNamePlaceholder: 't.ex. Teknisk rekryteringsprocess',
				templateDescription: 'Beskrivning',
				templateDescriptionPlaceholder: 'Valfri beskrivning',
				stageName: 'Stegnamn*',
				stageNamePlaceholder: 't.ex. Teknisk intervju',
				stageDescription: 'Beskrivning',
				stageDescriptionPlaceholder: 'Valfri beskrivning av detta steg',
				stageReviewDesc: 'Inledande granskning av ansökningar',
				stageScreening: 'Screening',
				stageScreeningDesc: 'Initial telefon- eller automatiserad screening',
				stageInterviewDesc: 'Formell intervjuprocess',
				stageAssessmentDesc: 'Färdighetstest eller arbetsprov',
				stageReferenceDesc: 'Kontroll av referenser',
				stageOfferDesc: 'Ge jobberbjudande',
				stageHiredDesc: 'Kandidat accepterade erbjudandet',
				stageRejectedDesc: 'Kandidat avslogs',
				saveSuccess: 'Pipeline-steg uppdaterades',
				saveError: 'Kunde inte uppdatera pipeline-steg',
				deleteTemplate: 'Ta bort mall',
				deleteTemplateConfirm: 'Är du säker på att du vill ta bort denna mall? Detta kan inte ångras.',
				cannotDeleteDefault: 'Standardmallen kan inte tas bort.',
				deleteSuccess: 'Mallen togs bort',
			},
			new: {
				title: 'Skapa en företagsprofil',
				subtitle: 'Skapa din företagsprofil för att publicera jobb och hantera ansökningar.',
				companyName: 'Företagsnamn *',
				companyNameRequired: 'Företagsnamn krävs',
				website: 'Webbplats',
				industry: 'Bransch',
				selectIndustry: 'Välj en bransch',
				location: 'Plats',
				locationPlaceholder: 'Stad, land',
				companySize: 'Företagsstorlek',
				selectCompanySize: 'Välj företagsstorlek',
				foundedYear: 'Grundat år',
				selectYear: 'Välj år',
				description: 'Företagsbeskrivning',
				descriptionPlaceholder: 'Berätta om företaget för potentiella kandidater...',
				creating: 'Skapar...',
				create: 'Skapa företag',
				size1to10: '1-10 anställda',
				size11to50: '11-50 anställda',
				size51to200: '51-200 anställda',
				size201to500: '201-500 anställda',
				size501to1000: '501-1000 anställda',
				size1001to5000: '1001-5000 anställda',
				size5001plus: '5001+ anställda',
				industryTechnology: 'Teknologi',
				industryHealthcare: 'Hälsa',
				industryFinance: 'Finans',
				industryEducation: 'Utbildning',
				industryManufacturing: 'Tillverkning',
				industryRetail: 'Detaljhandel',
				industryTransportation: 'Transport',
				industryEntertainment: 'Underhållning',
				industryConstruction: 'Bygg',
				industryEnergy: 'Energi',
				industryAgriculture: 'Jordbruk',
				industryOther: 'Övrigt',
			},
			team: {
				title: 'Teamhantering',
				subtitle: 'Hantera teammedlemmar och behörigheter',
				invite: 'Bjud in teammedlem',
				empty: 'Inga teammedlemmar hittades',
				inviteError: 'Kunde inte bjuda in medlem',
				removeError: 'Kunde inte ta bort medlem',
				updateRoleError: 'Kunde inte uppdatera roll',
				editRoleTitle: 'Redigera roll för teammedlem',
				sending: 'Skickar...',
				sendInvitation: 'Skicka inbjudan',
				email: 'E-postadress',
				role: 'Roll',
				memberLabel: 'Medlem',
				currentRole: 'Nuvarande roll',
				newRole: 'Ny roll',
				updateRole: 'Uppdatera roll',
				updating: 'Uppdaterar...',
				notJoinedYet: 'Inte ansluten ännu',
				rolePermissionsTitle: 'Rollbehörigheter',
				removeTitle: 'Ta bort teammedlem',
				removePrompt: 'Är du säker på att du vill ta bort',
				removePromptSuffix: 'från teamet? Detta kan inte ångras.',
				removeWarningTitle: 'Varning',
				removeWarningBody: 'Du tar bort en admin. Säkerställ att det finns minst en annan admin.',
				removing: 'Tar bort...',
				removeMember: 'Ta bort medlem',
				roles: {
					admin: 'Admin',
					recruiter: 'Rekryterare',
					hiringManager: 'Rekryterande chef',
					viewer: 'Läsare',
				},
			},
			communications: {
				title: 'Kommunikation',
				subtitle: 'Hantera kandidatkommunikation och e-postmallar',
				sendEmailTab: 'Skicka e-post',
				templatesTab: 'E-postmallar',
				validationMissing: 'Välj mottagare, ämne och innehåll',
				sendSuccessPrefix: 'E-post skickat till',
				sendSuccessSuffix: 'mottagare',
				sendError: 'Kunde inte skicka e-post',
				templateRequired: 'Mallnamn, ämne och innehåll krävs',
				templateSaved: 'E-postmallen sparades',
				templateSaveError: 'Kunde inte spara mallen',
				createTemplate: 'Skapa mall',
				createTemplateTitle: 'Skapa e-postmall',
				saveTemplate: 'Spara mall',
				recipients: 'Mottagare',
				selectAll: 'Välj alla',
				deselectAll: 'Avmarkera alla',
				selectedOf: 'av',
				composeEmail: 'Skriv e-post',
				selectTemplateOptional: 'Välj mall (valfritt)',
				selectTemplatePlaceholder: '-- Välj en mall --',
				emailSubject: 'Ämne',
				emailSubjectPlaceholder: 'Ange ämne',
				emailContent: 'Meddelande',
				emailContentPlaceholder: 'Skriv innehåll',
				templateName: 'Mallnamn*',
				templateNamePlaceholder: 't.ex. Intervjuinbjudan',
				templateSubject: 'Ämne*',
				templateSubjectPlaceholder: 't.ex. Intervjuinbjudan för {{position}} hos {{company}}',
				templateContent: 'Innehåll*',
				templateContentPlaceholder: 'Skriv mallens innehåll. Använd {{variable_name}} för dynamiskt innehåll.',
				availableVariables: 'Tillgängliga variabler',
				variablesHint: 'Använd dubbla klamrar för att infoga variabler, t.ex. {{variable}}. Vanliga variabler: {{candidate_name}}, {{position}}, {{company}}, {{interview_date}}, {{sender_name}}',
				useTemplate: 'Använd',
				templateVariables: 'Mallvariabler',
				templateVariablesHint: 'Variabler ersätts med kandidatspecifik information vid utskick.',
				sending: 'Skickar...',
				sendEmail: 'Skicka e-post',
				noCandidates: 'Inga kandidater tillgängliga',
				noTemplates: 'Inga e-postmallar tillgängliga',
			},
		},
		common: {
			save: 'Spara',
			cancel: 'Avbryt',
			loading: 'Laddar...',
			error: 'Ett fel uppstod',
			success: 'Lyckades',
		},
		auth: {
			emailNotConfirmed: 'E-postadressen är inte bekräftad',
			invalidEmail: 'Ogiltig e-postadress',
			passwordTooShort: 'Lösenordet måste vara minst 6 tecken',
			passwordRequired: 'Lösenord krävs',
			emailRequired: 'E-postadress krävs',
			verificationFailed: 'E-postbekräftelse misslyckades',
			signupFailed: 'Registrering misslyckades',
			loginFailed: 'Inloggning misslyckades',
			invalidCredentials: 'Ogiltiga inloggningsuppgifter',
			emailAlreadyExists: 'Ett konto med denna e-postadress finns redan',
			weakPassword: 'Lösenordet är för svagt',
			tooManyRequests: 'För många försök. Försök igen senare',
			networkError: 'Nätverksfel. Kontrollera din internetanslutning',
			unknownError: 'Ett oväntat fel uppstod',
		},
	},
	en: {
		settings: {
			title: 'Settings',
			subtitle: 'Manage your account settings and preferences',
			accountInfo: 'Account Information',
			email: 'Email Address',
			emailCannotChange: 'Cannot be changed',
			emailChangeContact: 'Contact support if you need to change your email address',
			preferences: 'Preferences',
			language: 'Language',
			languageDescription: 'Choose default language for the application',
			passwordChange: 'Change Password',
			passwordChangeDescription: 'Update your password for security',
			currentPassword: 'Current Password',
			newPassword: 'New Password',
			confirmPassword: 'Confirm Password',
			changePassword: 'Change Password',
			changingPassword: 'Changing password...',
			passwordChanged: 'Password has been changed',
			passwordMismatch: 'Passwords do not match',
			passwordTooShort: 'Password must be at least 6 characters',
			contact: 'Contact Us',
			contactDescription: 'Send a message to our support team',
			contactName: 'Name',
			contactEmail: 'Email',
			contactSubject: 'Subject',
			contactMessage: 'Message',
			sendMessage: 'Send Message',
			sending: 'Sending...',
			messageSent: 'Message sent! We will get back to you as soon as possible.',
			privacy: 'Privacy',
			exportData: 'Export Data',
			exportDataDescription: 'Download a copy of all your data',
			exporting: 'Exporting...',
			export: 'Export',
			accountManagement: 'Account Management',
			logout: 'Log Out',
			logoutDescription: 'You can log out from your account using the button in the navigation menu above.',
			deleteAccount: 'Delete Account',
			deleteAccountWarning: 'Warning: This will permanently delete your account and all your data. This action cannot be undone.',
			deleteAccountConfirm: 'Are you sure you want to delete your account? This cannot be undone.',
			deleteAccountConfirm2: 'This will permanently delete all your data. Are you absolutely sure?',
			deleting: 'Deleting...',
			deleteAccountButton: 'Delete Account',
			resetProfile: 'Reset Profile and Restart Onboarding',
			resetProfileWarning: 'This will delete driving license, languages, skills, job experiences, education, and certificates. You can then restart onboarding from Overview.',
			resetProfileConfirm: 'Are you sure you want to reset your profile? This will delete driving license, languages, skills, job experiences, education, and certificates.',
			resetProfileButton: 'Reset Profile and Restart Onboarding',
			resetting: 'Resetting...',
			resetProfileSuccess: 'Profile has been reset. You can now restart onboarding from Overview.',
			help: 'Need Help?',
			helpDescription: 'If you have questions or need support, contact us via email or check our help section.',
		},
		nav: {
			overview: 'Overview',
			search: 'Search',
			careerPaths: 'Career Paths',
			profile: 'Profile',
			documents: 'Documents',
			applications: 'Applications',
			interviewBuddy: 'Interview Buddy',
			statistics: 'Statistics',
			addJob: 'Add Job',
			settings: 'Settings',
			logout: 'Log Out',
			logoutTooltip: 'Log out from your account',
		},
		search: {
			matchMe: 'Match Me',
			search: 'Search',
			addJob: 'Add Job',
			addJobUnderDevelopment: 'Add Job - Under Development',
			comingSoon: 'This feature is coming soon!',
			whatWillThisDo: 'What will this feature do?',
			importJobs: 'Import jobs from external sources',
			importJobsDesc: 'Add job postings from LinkedIn or company websites directly to Karrelo to access all our features.',
			gapAnalysis: 'Gap analysis for external jobs',
			gapAnalysisDesc: 'Get a detailed analysis of which skills and experiences you lack to match the job perfectly.',
			matchScore: 'Match score and CV generation',
			matchScoreDesc: 'See how well you match the job and generate a tailored CV and cover letter based on the job posting.',
			trackApplications: 'Track all applications in one place',
			trackApplicationsDesc: 'Manage all your job applications, both from Karrelo and external sources, in a centralized view.',
			searchPlaceholder: 'Search role, keywords...',
			searchFieldEmpty: 'Search field cannot be empty. Please enter a search term.',
			county: 'County',
			selectCounty: 'Select county...',
			selectOneOrMoreCounties: 'Select one or more counties',
			extent: 'Extent',
			all: 'All',
			fullTime: 'Full Time',
			partTime: 'Part Time',
			selectExtent: 'Select extent',
			filter: 'Filter',
			applyFilter: 'Apply Filter',
			published: 'Published',
			today: 'Today',
			last7Days: 'Last 7 Days',
			last90Days: 'Last 90 Days',
			searchingJobs: 'Searching for jobs...',
			searchingJobsDesc: 'We are searching through job postings to find relevant results.',
			noAdsMatch: 'No ads match. Adjust filters or try a different search.',
			enterSearchTerms: 'Enter search terms or location to find job postings.',
			showing: 'Showing',
			of: 'of',
			ads: 'ads',
			filteredFrom: 'filtered from',
			total: 'total',
			previous: 'Previous',
			next: 'Next',
			page: 'Page',
		},
		addJob: {
			title: 'Add Job',
			subtitle: 'Add a job manually to get gap analysis, match score and CV generation.',
			instructions: 'Instructions',
			instructionsDesc: 'Open the job posting in your browser (LinkedIn, company website, etc.), copy the job description and paste it below along with company name and job title.',
			companyName: 'Company Name',
			companyPlaceholder: 'Ex: Acme Inc',
			jobTitle: 'Job Title',
			jobTitlePlaceholder: 'Ex: Frontend Developer',
			jobDescription: 'Job Description',
			descriptionPlaceholder: 'Paste or write the job description here...',
			location: 'Location',
			optional: 'optional',
			locationPlaceholder: 'Ex: Stockholm, Sweden',
			createJob: 'Create Job',
			creatingJob: 'Creating job...',
			mustBeLoggedIn: 'You must be logged in',
			requiredFields: 'Company, title and description are required',
			featureDisabled: 'This feature is currently disabled',
			couldNotCreateJob: 'Could not create job',
			errorOccurred: 'An error occurred',
		},
		matchMe: {
			matchYourProfile: 'Match your profile with jobs',
			analyzeProfileDesc: 'Click the button below to analyze your profile and get suggestions for suitable job titles.',
			analyzeMyProfile: 'Analyze My Profile',
			profileAnalysis: 'Profile Analysis',
			profileChanged: 'Your profile has changed',
			profileChangedDesc: 'Click "Update Profile Analysis" to get new suggestions based on your changes.',
			suitableJobTitles: 'Suitable Job Titles',
			selectTitles: 'Select Titles',
			updateAnalysis: 'Update Analysis',
			updateProfileAnalysis: 'Update Profile Analysis',
			selectJobTitlesToMatch: 'Select job titles to match against',
			allTitles: 'All Titles',
			clear: 'Clear',
			optimizedSearch: 'Optimized Search',
			optimizedSearchDesc: 'We use the 2 most relevant variants per title and max 10 search terms total for faster results and better performance. You can select all titles - the system automatically prioritizes the best matches.',
			backToProfileAnalysis: 'Back to Profile Analysis',
			searchWithSelectedTitles: 'Search with Selected Titles',
			filterResults: 'Filter Results',
			backToTitleSelection: 'Back to Title Selection',
			selectCounty: 'Select county...',
			selectOneOrMoreCounties: 'Select one or more counties',
			selectExtent: 'Select extent',
			published: 'Published',
			today: 'Today',
			last7Days: 'Last 7 Days',
			last90Days: 'Last 90 Days',
			matchMe: 'Match Me',
			filtering: 'Filtering...',
			searching: 'Searching...',
			searchingRelevantJobs: 'Searching for relevant jobs...',
			searchingJobsDesc: 'We are searching through thousands of job postings to find the best matches for you.',
			calculatingMatchScore: 'Calculating match score...',
			calculatingMatchScoreDesc: 'We analyze each job posting against your profile to give you the most relevant results.',
			backToFilters: 'Back to Filters',
			filterBySelectedCounties: 'Filter by selected counties',
			filterBySelectedTitles: 'Filter by selected titles',
			title: 'Title',
			selectTitlesPlaceholder: 'Select titles...',
			noTitlesSelected: 'No job titles selected. Please select at least one title.',
			errorOccurred: 'An error occurred',
			couldNotCalculateMatchScore: 'Could not calculate match score.',
			noJobsFound: 'No jobs with at least 20% match found. Try updating your profile with more skills or experience.',
			mustBeLoggedIn: 'You must be logged in to use the Match Me feature.',
			loginCheckError: 'An error occurred during login check.',
			fetchingJobAds: 'Fetching job postings...',
			scopeAll: 'All',
			scopeFullTime: 'Full Time',
			scopePartTime: 'Part Time',
			scopeTemporary: 'Temporary',
			scopePermanent: 'Permanent',
			scopeSummerJob: 'Summer Job',
			scopeInternship: 'Internship',
		},
		profile: {
			title: 'Profile',
			basicInfo: 'Basic Information',
			name: 'Name',
			fullName: 'Full name',
			phoneNumber: 'Phone Number',
			phonePlaceholder: 'e.g. +46 70 123 45 67',
			linkedin: 'LinkedIn Profile',
			linkedinPlaceholder: 'https://linkedin.com/in/your-name',
			email: 'Email',
			emailCannotChange: 'Email can be changed via account settings',
			notSpecified: 'Not specified',
			edit: 'Edit',
			save: 'Save',
			cancel: 'Cancel',
			drivingLicense: 'Driving License',
			hasLicense: 'Has driving license with the following categories:',
			noLicense: 'Does not have a driving license',
			languages: 'Languages',
			level: 'Level',
			addLanguage: 'Add new language',
			searchLanguage: 'Search language...',
			add: 'Add',
			skills: 'Skills',
			suggestSkills: 'Suggest skills',
			suggestions: 'Suggestions',
			newSkill: 'New skill',
			experiences: 'Experience',
			noExperiences: 'No experience added.',
			addExperience: 'Add new experience',
			employer: 'Employer',
			role: 'Role/Title',
			startDate: 'Start Date',
			endDate: 'End Date',
			ongoing: 'Ongoing',
			jobDescription: 'Job Description',
			jobDescriptionPlaceholder: 'Describe your tasks and responsibilities...',
			education: 'Education',
			noEducation: 'No education added.',
			school: 'School',
			degree: 'Degree',
			fieldOfStudy: 'Field of Study',
			levelPlaceholder: 'Level',
			addEducation: 'Add',
			certifications: 'Certifications',
			noCertifications: 'No certifications added.',
			certName: 'Name',
			issuer: 'Issuer',
			issuedAt: 'Issued At',
			expiresAt: 'Expires At',
		},
		documents: {
			title: 'My Documents',
			subtitle: 'Manage your AI-generated CVs and cover letters grouped by job posting',
			loading: 'Loading documents...',
			jobAds: 'Job Postings',
			cvs: 'CVs',
			coverLetters: 'Cover Letters',
			noDocuments: 'No documents yet',
			noDocumentsDesc: 'Generate your first ATS-optimized CV or cover letter from a job posting.',
			searchJobs: 'Search Jobs',
			jobId: 'Job ID',
			created: 'Created',
			deleteAll: 'Delete All',
			cv: 'CV',
			coverLetter: 'Cover Letter',
			delete: 'Delete',
			noCv: 'No CV',
			noCoverLetter: 'No cover letter',
			atsKeywords: 'ATS Keywords:',
			deleteConfirm: 'Are you sure you want to delete this',
			deleteConfirmAll: 'Are you sure you want to delete all documents for this job? This will delete both CV and cover letter.',
			couldNotDelete: 'Could not delete document',
			errorOccurred: 'An error occurred',
			downloadFailed: 'Download failed:',
			searchJobTitle: 'Search by job title',
			searchJobTitlePlaceholder: 'Search by job title or company...',
			dateFrom: 'From date',
			dateTo: 'To date',
		},
		applications: {
			title: 'Applications',
			subtitle: 'Drag and drop cards to update status',
			subtitleMobile: 'Tap the menu to change status',
			totalApplications: 'total applications',
			noApplications: 'No applications yet',
			noApplicationsDesc: 'Save job postings to start tracking your applications.',
			searchJobs: 'Search Jobs',
			saved: 'Saved',
			applied: 'Applied',
			interviews: 'Interviews',
			offers: 'Offers',
			rejected: 'Rejected',
			noApplicationsHere: 'No applications here',
			changeStatus: 'Change status',
			match: 'match',
			appliedOn: 'Applied:',
			interviewOn: 'Interview:',
			view: 'View',
			help: 'Help',
			applicationHelp: 'Open application help',
			mustApplyFirst: 'Application must be marked as "Applied" before it can be moved to other statuses',
			mustBeLoggedIn: 'You must be logged in',
			couldNotLoad: 'Could not load applications',
			errorOccurred: 'An error occurred',
			tryAgain: 'Try Again',
		},
		statistics: {
			title: 'Statistics',
			subtitle: 'Analyze your applications and track your progress',
			subtitleWithTime: 'Analyze your applications and track your progress over time',
			noApplications: 'No applications yet',
			noApplicationsDesc: 'Save job postings to start seeing statistics.',
			searchJobs: 'Search Jobs',
			mustBeLoggedIn: 'You must be logged in',
			couldNotLoad: 'Could not load applications',
			errorOccurred: 'An error occurred',
			tryAgain: 'Try Again',
			exportApplications: 'Export Applications',
			exportDesc: 'Export your applied jobs for activity report to the Employment Service',
			selectMonth: 'Select a month to export',
			exporting: 'Exporting...',
			exportToExcel: 'Export to Excel',
			noAppliedJobs: 'No applied jobs yet',
			noAppliedJobsDesc: 'Mark jobs as "Applied" in Applications to export',
			averagePerMonth: 'Average per month',
			sinceFirstJob: 'Since first job',
			month: 'month',
			months: 'months',
			noDataYet: 'No data yet',
			activeApplications: 'Active Applications',
			ongoingProcesses: 'Ongoing processes',
			monthlyTrend: 'Monthly Trend',
			applicationsPerMonth: 'Number of applications per month',
			sinceFirstJobDesc: 'Number of applications per month since first job',
			statusDistribution: 'Status Distribution',
			statusDistributionDesc: 'Distribution of your applications by status',
			statusDistributionBar: 'Status Distribution (Bar Chart)',
			statusDistributionBarDesc: 'Number of applications per status',
			applications: 'Applications',
		},
		dashboard: {
			welcome: 'Welcome to Karrelo',
			greetingPrefix: 'Hello',
			greetingSuffix: '!',
			overview: 'Here is an overview of your career journey',
			completeProfile: 'Complete your profile',
			completeProfileDesc: 'To get better matches, we need to know more about you.',
			getStarted: 'Get Started',
			applications: 'Applications',
			activeApplications: 'Active applications',
			savedJobs: 'Saved jobs',
			profileComplete: 'Profile complete',
			profileIncomplete: 'Profile incomplete',
			quickActions: 'Quick Actions',
			searchJobs: 'Search Jobs',
			searchJobsDesc: 'Find jobs that match your profile with AI-driven matching',
			exploreCareers: 'Explore Career Paths',
			exploreCareersDesc: 'Get personalized job suggestions based on your profile',
			viewProfile: 'Update Profile',
			viewProfileDesc: 'Add skills, experiences and education for better matches',
			viewApplications: 'Manage Applications',
			viewApplicationsDesc: 'View and track all your applications in one place',
			getStartedTitle: 'Get Started with Karrelo',
			getStartedDesc: 'Complete your profile to get better job matches and personalized CV suggestions. It only takes a few minutes!',
			startOnboarding: 'Start Onboarding',
			totalApplications: 'Total Applications',
			totalApplicationsDesc: 'All applications you tracked',
			activeApplicationsDesc: 'Ongoing processes',
			savedJobsDesc: 'Jobs to apply to later',
		},
		company: {
			auth: {
				loginRequired: 'Please log in',
			},
			errors: {
				loadCompany: 'Failed to load company details',
				companyNotFound: 'Company not found.',
				loadDashboard: 'Failed to load dashboard data',
				noDashboardData: 'No dashboard data available.',
				loadSettings: 'Failed to load settings',
				saveSettings: 'Failed to save settings',
				loadJobs: 'Failed to load jobs',
				loadAnalytics: 'Failed to load analytics',
				createCompany: 'Failed to create company',
				uploadLogo: 'Failed to upload logo',
				updateCompany: 'Failed to update company',
				save: 'Failed to save',
				loadApplications: 'Failed to load applications',
				loadInterviews: 'Failed to load interviews',
				unknown: 'Unknown error',
				unauthorized: 'Unauthorized',
				loadApplication: 'Failed to load application',
				updateStage: 'Failed to update stage',
				addNote: 'Failed to add note',
				loadTeam: 'Failed to load team',
			},
			actions: {
				retry: 'Retry',
				settings: 'Settings',
				createJob: 'Create job',
				logout: 'Log out',
				openMenu: 'Open menu',
				closeMenu: 'Close menu',
				clear: 'Clear',
				clearSearch: 'Clear search',
				clearFilters: 'Clear filters',
				saving: 'Saving...',
				saveChanges: 'Save changes',
				actions: 'Actions',
				edit: 'Edit',
				preview: 'Preview',
				review: 'Review',
				download: 'Download',
				remove: 'Remove',
			},
			layout: {
				portal: 'Company portal',
				companyLabel: 'Company',
				lightMode: 'Light mode',
				darkMode: 'Dark mode',
				switchToLight: 'Switch to light mode',
				switchToDark: 'Switch to dark mode',
			},
			nav: {
				dashboard: 'Dashboard',
				jobs: 'Jobs',
				applications: 'Applications',
				interviews: 'Interviews',
				analytics: 'Analytics',
				team: 'Team',
				settings: 'Settings',
			},
			dashboard: {
				activeJobs: 'Active jobs',
				totalApplications: 'Total applications',
				newApplications: 'New applications',
				toReview: 'To review',
				upcomingInterviews: 'Interviews',
				quickActions: 'Quick actions',
				manageJobs: 'Manage jobs',
				manageJobsDesc: 'View, edit, and create job ads',
				reviewApplications: 'Review applications',
				reviewApplicationsDesc: 'Review and manage applications',
				scheduleInterviews: 'Schedule interviews',
				scheduleInterviewsDesc: 'Manage candidate interviews',
				manageTeam: 'Manage team',
				manageTeamDesc: 'Add and manage team members',
				recentActivity: 'Recent activity',
				noRecentActivity: 'No recent activity',
				viewAllActivity: 'View all activity →',
				upcomingInterviewsTitle: 'Upcoming interviews',
				noUpcomingInterviews: 'No upcoming interviews',
				viewAllInterviews: 'View all interviews →',
			},
			jobs: {
				title: 'Job listings',
				subtitle: 'Create and manage your job postings',
				statusDraft: 'Draft',
				statusScheduled: 'Scheduled',
				statusExpired: 'Expired',
				statusActive: 'Active',
				filters: 'Filters',
				filter: 'Filter',
				search: 'Search',
				filterAll: 'All jobs',
				filterDrafts: 'Drafts',
				searchPlaceholder: 'Search jobs...',
				noJobsTitle: 'No jobs found',
				noJobsFiltered: 'Try adjusting your search or filters',
				noJobsEmpty: 'Create your first job posting to get started',
				tableTitle: 'Job title',
				tableLocation: 'Location',
				tableStatus: 'Status',
				tableApplications: 'Applications',
				tableCreated: 'Created',
				viewApplications: 'View applications',
				noLocation: 'No location specified',
			},
			activity: {
				title: 'Activity',
				subtitle: 'Activity feed coming soon.',
			},
			analytics: {
				title: 'Recruitment analytics',
				subtitle: 'Track hiring metrics and optimize your process',
				dateRange: 'Date range:',
				range7d: 'Last 7 days',
				range30d: 'Last 30 days',
				range90d: 'Last 90 days',
				rangeAll: 'All time',
				jobFilter: 'Job:',
				noAccess: 'You do not have access to company analytics.',
				noData: 'No analytics data available.',
				totalApplications: 'Total applications',
				conversionRate: 'Conversion rate',
				timeToHire: 'Time to hire',
				days: 'days',
				totalHires: 'Total hires',
				applicationsOverTime: 'Applications over time',
				applications: 'Applications',
				jobPerformance: 'Job performance',
				views: 'Views',
				interviews: 'Interviews',
				hires: 'Hires',
				applicationSources: 'Application sources',
				timeToHireByStage: 'Time to hire by stage',
				avgTime: 'Average time',
				avgDays: 'Average days',
				candidatesByStage: 'Candidates by stage',
				candidates: 'Candidates',
				topSkills: 'Top skills',
				count: 'Count',
				exportCsv: 'Export CSV',
				exportPdf: 'Export PDF',
			},
			interviews: {
				title: 'Interviews',
				subtitle: 'Manage scheduled interviews',
				defaultType: 'Phone interview',
				statusScheduled: 'Scheduled',
				statusCompleted: 'Completed',
				statusCancelled: 'Cancelled',
				emptyTitle: 'No interviews found',
				emptySubtitle: 'Schedule interviews from the Applications page',
				emptyFiltered: 'No interviews with status',
				tableCandidate: 'Candidate',
				tableJob: 'Job',
				tableScheduled: 'Scheduled',
				tableType: 'Type',
				tableStatus: 'Status',
				viewApplication: 'View application',
			},
			filters: {
				all: 'All',
			},
			applications: {
				title: 'Applications',
				subtitle: 'Manage and track candidate applications',
				filters: 'Filters',
				search: 'Search',
				job: 'Job',
				stage: 'Stage',
				view: 'View',
				scoreStatus: 'Score status',
				tabOverview: 'Overview',
				tabAiSummary: 'AI summary',
				tabCvDocuments: 'Resume & docs',
				tabQuestions: 'Screening questions',
				tabNotes: 'Notes',
				showMore: 'Show more',
				showLess: 'Show less',
				more: 'more',
				comingSoon: 'Coming soon',
				overviewMatch: 'Match',
				overviewMatchSubtitle: 'Quick overview of match and evidence',
				overviewStrengths: 'Strengths',
				overviewRisks: 'Risks / gaps',
				openAiSummary: 'Open AI summary',
				applicant: 'Candidate',
				latestNotes: 'Latest notes',
				latestNotesSubtitle: 'Collaboration and follow-ups in one place',
				openNotes: 'Open notes',
				evidenceSkills: 'Key skills',
				evidenceSubtitle: 'Signals from summary and resume',
				noEvidence: 'No clear key skills yet.',
				noStrengths: 'No strengths provided.',
				noRisks: 'No risks/gaps provided.',
				noAiSummary: 'No AI summary yet. Generate one for a quick overview.',
				coverLetterSubtitle: 'Preview the candidate’s cover letter',
				noCoverLetter: 'No cover letter.',
				resumeSubtitle: 'Open or download the candidate’s resume',
				questionsSubtitle: 'Answers to screening questions',
				noQuestions: 'No screening questions found.',
				dangerZone: 'Danger zone',
				dangerZoneSubtitle: 'Delete application (cannot be undone).',
				total: 'Total applications',
				new: 'New applications',
				inInterview: 'In interview',
				offersSent: 'Offers sent',
				allStages: 'All stages',
				stageNew: 'New',
				stageReviewed: 'Reviewed',
				stageInterview: 'Interview',
				stageAssessment: 'Assessment',
				stageReferenceCheck: 'Reference check',
				stageOffer: 'Offer',
				stageHired: 'Hired',
				stageRejected: 'Rejected',
				stageOther: 'Other',
				stageUnknown: 'Unknown stage',
				stageOutsideTemplate: 'This stage is not part of the active pipeline.',
				viewKanban: 'Kanban',
				viewList: 'List',
				searchPlaceholder: 'Search applicants...',
				matchScoreAny: 'Match score: any',
				matchScoreAbove40: 'Match score ≥ 40%',
				matchScoreAbove60: 'Match score ≥ 60%',
				matchScoreAbove80: 'Match score ≥ 80%',
				scoreStatusAll: 'Score status: all',
				scoreStatusDone: 'Score status: completed',
				scoreStatusPending: 'Score status: in progress',
				scoreStatusFailed: 'Score status: failed',
				showStages: 'Show stages',
				emptyTitle: 'No applications found',
				emptyFiltered: 'Try adjusting your filters',
				emptyDefault: 'Post a job to start receiving applications',
				candidates: 'candidates',
				noApplications: 'No applications',
				tableApplicant: 'Applicant',
				tableJob: 'Job',
				tableStage: 'Stage',
				tableScore: 'Match score',
				tableApplied: 'Applied',
				tableUpdated: 'Updated',
				unassigned: 'Unassigned',
				scoring: 'Scoring...',
				updating: 'Updating...',
				notFound: 'Application not found.',
				backToList: 'Back to applications',
				backToApplication: 'Back to application',
				applicationFor: 'Application for',
				appliedOn: 'Applied',
				email: 'Email',
				phone: 'Phone',
				linkedinProfile: 'LinkedIn profile',
				matchScore: 'Match score',
				coverLetter: 'Cover letter',
				cvSummary: 'CV summary',
				cvSummaryExecutive: 'Summary',
				cvSummaryStrengths: 'Strengths (for this job)',
				cvSummaryWeaknesses: 'Areas for development',
				cvSummaryRelevance: 'Match to job',
				cvSummaryHighlights: 'Highlights',
				cvSummarySkills: 'Top skills',
				cvSummaryExperience: 'Experience',
				cvSummaryYears: 'years of experience',
				cvSummaryRoles: 'Recent roles',
				cvSummaryEducation: 'Education',
				generateAiSummaryTest: 'Generate AI summary (test)',
				screeningQuestions: 'Screening questions',
				question: 'Question',
				resume: 'Resume',
				resumeFile: 'Resume.pdf',
				viewResume: 'View resume',
				noResume: 'No resume uploaded',
				stageTitle: 'Application stage',
				currentStage: 'Current stage',
				quickActions: 'Quick actions',
				scheduleInterview: 'Schedule interview',
				sendEmail: 'Send email',
				offerStageNotFound: 'Offer stage not found',
				rejectedStageNotFound: 'Rejected stage not found',
				extendOffer: 'Extend offer',
				reject: 'Reject',
				notes: 'Notes',
				addNotePlaceholder: 'Add a note...',
				privateNote: 'Private note',
				privateNoteSelf: 'Private note (only visible to you)',
				addNote: 'Add note',
				userFallback: 'User',
				noNotes: 'No notes yet',
				currentUser: 'Current user',
				teamNotesTitle: 'Team notes & collaboration',
				addNoteMentionPlaceholder: 'Add a note or mention a team member with @',
				teamNotes: 'Team notes',
				noNotesCta: 'No notes yet. Be the first to add a note!',
				private: 'Private',
				adding: 'Adding...',
				deleteApplication: 'Delete application',
				deleteApplicationConfirm: 'Are you sure you want to delete this application? The candidate and all related information will be permanently removed.',
				deleteApplicationSuccess: 'Application deleted',
				couldNotDeleteApplication: 'Could not delete application',
				deleting: 'Deleting...',
			},
			onboarding: {
				websiteLocationRequired: 'Please fill in website and location.',
				completeSuccess: 'Onboarding complete!',
				title: 'Welcome! Complete onboarding',
				subtitle: 'We need some basic info to complete your company profile.',
				website: 'Company website',
				websitePlaceholder: 'https://example.com',
				location: 'Location',
				locationPlaceholder: 'e.g., Stockholm, Sweden',
				logo: 'Logo (optional)',
				logoAlt: 'Company logo',
				upload: 'Upload',
				logoHint: 'PNG, JPG, WEBP, or SVG. Max 5 MB.',
				complete: 'Complete onboarding',
			},
			settings: {
				title: 'Company settings',
				subtitle: 'Manage your company profile and preferences',
				generalTab: 'General',
				pipelineTab: 'Hiring pipeline',
				companyNameLabel: 'Company name *',
				industryLabel: 'Industry',
				industryPlaceholder: 'e.g., Technology, Healthcare, Finance',
				websiteLabel: 'Website',
				websitePlaceholder: 'https://example.com',
				descriptionLabel: 'Description',
				descriptionPlaceholder: 'Tell us about your company...',
				saveSuccess: 'Settings saved successfully',
			},
			pipeline: {
				title: 'Pipeline settings',
				subtitle: 'Customize your hiring pipeline stages',
				firstStageRequired: 'The first stage (New) cannot be removed.',
				loadError: 'Failed to load pipeline data',
				templatesTitle: 'Pipeline templates',
				templatesSubtitle: 'Choose a template to customize or create a new one',
				stagesTitle: 'Pipeline stages',
				stagesSubtitle: 'Drag and drop to reorder. Click to edit.',
				defaultTemplate: 'Default pipeline',
				defaultTemplateDesc: 'Standard hiring pipeline for all positions',
				technicalTemplate: 'Technical roles',
				technicalTemplateDesc: 'Pipeline with technical assessment focus',
				executiveTemplate: 'Executive hiring',
				executiveTemplateDesc: 'Pipeline for executive and leadership positions',
				createTemplate: 'Create template',
				createTemplateTitle: 'Create new template',
				addStage: 'Add stage',
				addStageTitle: 'Add new stage',
				stageCatalogLabel: 'Choose existing stage',
				stageCatalogPlaceholder: 'Select from catalog',
				defaultTag: 'Default',
				templateName: 'Template name*',
				templateNamePlaceholder: 'e.g., Technical hiring process',
				templateDescription: 'Description',
				templateDescriptionPlaceholder: 'Optional description',
				stageName: 'Stage name*',
				stageNamePlaceholder: 'e.g., Technical interview',
				stageDescription: 'Description',
				stageDescriptionPlaceholder: 'Optional description of this stage',
				stageReviewDesc: 'Initial review of applications',
				stageScreening: 'Screening',
				stageScreeningDesc: 'Initial phone or automated screening',
				stageInterviewDesc: 'Formal interview process',
				stageAssessmentDesc: 'Skills assessment or test',
				stageReferenceDesc: 'Checking professional references',
				stageOfferDesc: 'Extending job offer',
				stageHiredDesc: 'Candidate accepted offer',
				stageRejectedDesc: 'Candidate was rejected',
				saveSuccess: 'Pipeline stages updated successfully',
				saveError: 'Failed to update pipeline stages',
				deleteTemplate: 'Delete template',
				deleteTemplateConfirm: 'Are you sure you want to delete this template? This cannot be undone.',
				cannotDeleteDefault: 'The default template cannot be deleted.',
				deleteSuccess: 'Template deleted',
			},
			new: {
				title: 'Create a company profile',
				subtitle: 'Create your company profile to start posting jobs and managing applications.',
				companyName: 'Company name *',
				companyNameRequired: 'Company name is required',
				website: 'Website',
				industry: 'Industry',
				selectIndustry: 'Select an industry',
				location: 'Location',
				locationPlaceholder: 'City, Country',
				companySize: 'Company size',
				selectCompanySize: 'Select company size',
				foundedYear: 'Founded year',
				selectYear: 'Select year',
				description: 'Company description',
				descriptionPlaceholder: 'Tell potential candidates about your company...',
				creating: 'Creating...',
				create: 'Create company',
				size1to10: '1-10 employees',
				size11to50: '11-50 employees',
				size51to200: '51-200 employees',
				size201to500: '201-500 employees',
				size501to1000: '501-1000 employees',
				size1001to5000: '1001-5000 employees',
				size5001plus: '5001+ employees',
				industryTechnology: 'Technology',
				industryHealthcare: 'Healthcare',
				industryFinance: 'Finance',
				industryEducation: 'Education',
				industryManufacturing: 'Manufacturing',
				industryRetail: 'Retail',
				industryTransportation: 'Transportation',
				industryEntertainment: 'Entertainment',
				industryConstruction: 'Construction',
				industryEnergy: 'Energy',
				industryAgriculture: 'Agriculture',
				industryOther: 'Other',
			},
			team: {
				title: 'Team management',
				subtitle: 'Manage team members and their permissions',
				invite: 'Invite team member',
				empty: 'No team members found',
				inviteError: 'Failed to invite member',
				removeError: 'Failed to remove member',
				updateRoleError: 'Failed to update role',
				editRoleTitle: 'Edit team member role',
				sending: 'Sending...',
				sendInvitation: 'Send invitation',
				email: 'Email address',
				role: 'Role',
				memberLabel: 'Member',
				currentRole: 'Current role',
				newRole: 'New role',
				updateRole: 'Update role',
				updating: 'Updating...',
				notJoinedYet: 'Not joined yet',
				rolePermissionsTitle: 'Role permissions',
				removeTitle: 'Remove team member',
				removePrompt: 'Are you sure you want to remove',
				removePromptSuffix: 'from the team? This action cannot be undone.',
				removeWarningTitle: 'Warning',
				removeWarningBody: 'You are removing an admin. Make sure there is at least one other admin.',
				removing: 'Removing...',
				removeMember: 'Remove member',
				roles: {
					admin: 'Admin',
					recruiter: 'Recruiter',
					hiringManager: 'Hiring manager',
					viewer: 'Viewer',
				},
			},
			communications: {
				title: 'Communications',
				subtitle: 'Manage candidate communications and email templates',
				sendEmailTab: 'Send email',
				templatesTab: 'Email templates',
				validationMissing: 'Please select recipients, subject, and message content',
				sendSuccessPrefix: 'Email sent to',
				sendSuccessSuffix: 'recipients',
				sendError: 'Failed to send email',
				templateRequired: 'Template name, subject, and content are required',
				templateSaved: 'Email template saved successfully',
				templateSaveError: 'Failed to save template',
				createTemplate: 'Create template',
				createTemplateTitle: 'Create email template',
				saveTemplate: 'Save template',
				recipients: 'Recipients',
				selectAll: 'Select all',
				deselectAll: 'Deselect all',
				selectedOf: 'of',
				composeEmail: 'Compose email',
				selectTemplateOptional: 'Select template (optional)',
				selectTemplatePlaceholder: '-- Select a template --',
				emailSubject: 'Subject',
				emailSubjectPlaceholder: 'Enter subject',
				emailContent: 'Message',
				emailContentPlaceholder: 'Enter content',
				templateName: 'Template name*',
				templateNamePlaceholder: 'e.g., Interview invitation',
				templateSubject: 'Subject*',
				templateSubjectPlaceholder: 'e.g., Interview invitation for {{position}} at {{company}}',
				templateContent: 'Content*',
				templateContentPlaceholder: 'Enter template content. Use {{variable_name}} for dynamic content.',
				availableVariables: 'Available variables',
				variablesHint: 'Use double curly braces to insert variables, for example: {{variable}}. Common variables: {{candidate_name}}, {{position}}, {{company}}, {{interview_date}}, {{sender_name}}',
				useTemplate: 'Use',
				templateVariables: 'Template variables',
				templateVariablesHint: 'Variables will be replaced with candidate-specific information when sending.',
				sending: 'Sending...',
				sendEmail: 'Send email',
				noCandidates: 'No candidates available',
				noTemplates: 'No email templates available',
			},
		},
		common: {
			save: 'Save',
			cancel: 'Cancel',
			loading: 'Loading...',
			error: 'An error occurred',
			success: 'Success',
		},
		auth: {
			emailNotConfirmed: 'Email address is not confirmed',
			invalidEmail: 'Invalid email address',
			passwordTooShort: 'Password must be at least 6 characters',
			passwordRequired: 'Password is required',
			emailRequired: 'Email address is required',
			verificationFailed: 'Email verification failed',
			signupFailed: 'Signup failed',
			loginFailed: 'Login failed',
			invalidCredentials: 'Invalid credentials',
			emailAlreadyExists: 'An account with this email address already exists',
			weakPassword: 'Password is too weak',
			tooManyRequests: 'Too many requests. Please try again later',
			networkError: 'Network error. Check your internet connection',
			unknownError: 'An unexpected error occurred',
		},
	},
} as const;

export type TranslationKey = keyof typeof translations.sv;

